import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import DashboardPage from "./pages/DashboardPage";
import ClientsPage from "./pages/ClientsPage";
import ClientFormPage from "./pages/ClientFormPage";
import ClientDetailPage from "./pages/ClientDetailPage";
import RecordsPage from "./pages/RecordsPage";
import RecordFormPage from "./pages/RecordFormPage";
import BillingPage from "./pages/BillingPage";
import DocumentsPage from "./pages/DocumentsPage";
import FacilitiesPage from "./pages/FacilitiesPage";
import TemplatesPage from "./pages/TemplatesPage";
import SupportPlansPage from "./pages/SupportPlansPage";
import SupportPlanFormPage from "./pages/SupportPlanFormPage";
import IncidentsPage from "./pages/IncidentsPage";
import IncidentFormPage from "./pages/IncidentFormPage";
import SubscriptionPage from "./pages/SubscriptionPage";
import StaffPage from "./pages/StaffPage";
import ShiftsPage from "./pages/ShiftsPage";
import FacilityUsersPage from "./pages/FacilityUsersPage";
import FacilitySettingsPage from "./pages/FacilitySettingsPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import PDFDesignPage from "./pages/PDFDesignPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* 公開ルート */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          
          {/* 保護されたルート */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Layout>
                  <DashboardPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/clients"
            element={
              <ProtectedRoute>
                <Layout>
                  <ClientsPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/clients/new"
            element={
              <ProtectedRoute>
                <Layout>
                  <ClientFormPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/clients/:clientId/edit"
            element={
              <ProtectedRoute>
                <Layout>
                  <ClientFormPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/clients/:clientId"
            element={
              <ProtectedRoute>
                <Layout>
                  <ClientDetailPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/records"
            element={
              <ProtectedRoute>
                <Layout>
                  <RecordsPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/records/new"
            element={
              <ProtectedRoute>
                <Layout>
                  <RecordFormPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/records/:recordId/edit"
            element={
              <ProtectedRoute>
                <Layout>
                  <RecordFormPage />
                </Layout>
              </ProtectedRoute>
            }
          />

          
          <Route
            path="/billing"
            element={
              <ProtectedRoute>
                <Layout>
                  <BillingPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/documents"
            element={
              <ProtectedRoute>
                <Layout>
                  <DocumentsPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/facilities"
            element={
              <ProtectedRoute>
                <Layout>
                  <FacilitiesPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/facility-settings"
            element={
              <ProtectedRoute>
                <Layout>
                  <FacilitySettingsPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/templates"
            element={
              <ProtectedRoute>
                <Layout>
                  <TemplatesPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/support-plans"
            element={
              <ProtectedRoute>
                <Layout>
                  <SupportPlansPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/support-plans/new"
            element={
              <ProtectedRoute>
                <Layout>
                  <SupportPlanFormPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/support-plans/:planId/edit"
            element={
              <ProtectedRoute>
                <Layout>
                  <SupportPlanFormPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/incidents"
            element={
              <ProtectedRoute>
                <Layout>
                  <IncidentsPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/incidents/new"
            element={
              <ProtectedRoute>
                <Layout>
                  <IncidentFormPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/incidents/:incidentId/edit"
            element={
              <ProtectedRoute>
                <Layout>
                  <IncidentFormPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/subscription"
            element={
              <ProtectedRoute>
                <Layout>
                  <SubscriptionPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/staff"
            element={
              <ProtectedRoute>
                <Layout>
                  <StaffPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/shifts"
            element={
              <ProtectedRoute>
                <Layout>
                  <ShiftsPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/users"
            element={
              <ProtectedRoute>
                <Layout>
                  <FacilityUsersPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Layout>
                  <AdminDashboardPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/pdf-design"
            element={
              <ProtectedRoute>
                <Layout>
                  <PDFDesignPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          
          {/* デフォルトリダイレクト */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </AuthProvider>
  );
}

export default App;
